import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { MainBlockContainer } from '../../containers/main_block';
import { NavigationContainer } from '../../containers/navigation';
import { SideBlockContainer } from '../../containers/side_block';
import { isPreviousRouteFirst } from '../../utils/routerHelper';
import { ConditionalWrap } from '../ConditionalWrap/ConditionalWrap';
import * as styles from './index.css';
import './mvk-fotorama.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var NewbuildingMVK = /*#__PURE__*/function (_React$Component) {
  _inherits(NewbuildingMVK, _React$Component);
  var _super = _createSuper(NewbuildingMVK);
  function NewbuildingMVK() {
    var _this;
    _classCallCheck(this, NewbuildingMVK);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handlePopState", function () {
      if (isPreviousRouteFirst()) {
        window.history.back();
        return;
      }
      _this.props.handleUndoRedoButtonClick();
    });
    return _this;
  }
  _createClass(NewbuildingMVK, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.onpopstate = this.handlePopState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isFullScreen = _this$props.isFullScreen,
        containerStyles = _this$props.containerStyles,
        onClose = _this$props.onClose,
        menuRender = _this$props.menuRender;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ConditionalWrap, {
          wrap: menuRender,
          children: /*#__PURE__*/_jsx(NavigationContainer, {
            onClose: onClose
          }, 1)
        }), /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, mergeStyles(styles['content'], isFullScreen && styles['content--fullscreen'], containerStyles)), {}, {
          children: [/*#__PURE__*/_jsx(MainBlockContainer, {}), /*#__PURE__*/_jsx(SideBlockContainer, {})]
        }), 2)]
      });
    }
  }]);
  return NewbuildingMVK;
}(React.Component);